// extracted by mini-css-extract-plugin
export default {"modal":"Bga-z","modalContent":"Cga-z","footer":"Dga-z","cancelBtn":"Ega-z","disabled":"Fga-z","formWrapper":"Gga-z","fade":"Hga-z","fade-in":"Iga-z","iframe":"Jga-z"};